/* template */
<template><page><div :class='["checkbox-page"]'><base-container><default-checked-checkbox></default-checked-checkbox><disabled-checkbox></disabled-checkbox><desc-checkbox></desc-checkbox><styled-checkbox></styled-checkbox></base-container></div></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_d7c436ae"}'>
.checkbox-page
  height 100%
  background-color rgba(239, 239, 244, .7)
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_d7c436ae"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_d7c436ae"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_d7c436ae"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {"styleIsolation":"shared"},
    // @ts-ignore
    componentsMap: {'desc-checkbox':getComponent(require("./desc-support.mpx?isComponent&outputPath=components%2Fdesc-support280dae6c%2Findex")),'styled-checkbox':getComponent(require("./styled.mpx?isComponent&outputPath=components%2Fstyled636795ec%2Findex")),'disabled-checkbox':getComponent(require("./disabled.mpx?isComponent&outputPath=components%2Fdisabled46f93e33%2Findex")),'default-checked-checkbox':getComponent(require("./default-checked.mpx?isComponent&outputPath=components%2Fdefault-checkedb79d991c%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>